import React, { forwardRef } from 'react';
import { TextField as MuiTextField, TextFieldProps } from '@mui/material';

export const TextField = forwardRef<
  React.FC<React.ComponentProps<typeof MuiTextField>>,
  TextFieldProps
>((props, ref) => {
  return <MuiTextField {...props} inputRef={ref} />;
});

TextField.displayName = 'TextField';
